import type { HomeTestimonial } from "@/types/home-messages";

export const HOME_TESTIMONIAL_VISIBLE_CARD_COUNT = 3;
export const HOME_TESTIMONIAL_ROTATION_INTERVAL_MS = 8_000;

export function getVisibleTestimonials(
  items: HomeTestimonial[],
  currentIndex: number,
): Array<HomeTestimonial & { itemIndex: number }> {
  if (items.length === 0) return [];

  return Array.from(
    {
      length: Math.min(HOME_TESTIMONIAL_VISIBLE_CARD_COUNT, items.length),
    },
    (_, offset) => {
      const itemIndex = (currentIndex + offset) % items.length;
      return { ...items[itemIndex], itemIndex };
    },
  );
}
